let gameLoopParticipants = [];
let loopTicker = null;
let oldTime = null;

export function loopAnimation() {
  const newTime = Date.now();
  let deltaTime = newTime - oldTime;
  oldTime = newTime;
  deltaTime = Math.max(0, Math.min(deltaTime, 1000));
  let deltaFrame = (deltaTime * 60) / 1000;
  deltaFrame = deltaFrame <= 1.5 ? deltaFrame : 1.5;
  gameLoopParticipants.forEach((actionInfo) => {
    actionInfo.callback.call(
      actionInfo.context,
      loopTicker.lastTime + loopTicker.elapsedMS,
      deltaFrame
    );
  });
}

export function initGameLoopManager(ticker) {
  loopTicker = ticker;
  ticker.maxFPS = 60;
  loopTicker.add(loopAnimation);
}

export function addToGameLoop(callback, context) {
  gameLoopParticipants.push({ callback, context });
}

export function removeFromGameLoop(callback, context) {
  gameLoopParticipants = gameLoopParticipants.filter(
    (executable) => executable.callback !== callback || executable.context !== context
  );
}

export function clearGameLoopManager() {
  gameLoopParticipants.forEach((executable) => {
    if (executable.callback.isTime) loopTicker.remove(executable.callback, executable.context);
  });
  gameLoopParticipants = gameLoopParticipants.filter((executable) => !executable.callback.isTime);
}

export function clearGameLoopManagerByTime() {
  gameLoopParticipants.forEach((executable) => {
    if (!executable.callback.isTime) loopTicker.remove(executable.callback, executable.context);
  });
  gameLoopParticipants = gameLoopParticipants.filter((executable) => executable.callback.isTime);
}

export function getGameLastTime() {
  return loopTicker.lastTime;
}
